import { HANDLE_EMPLOYEE, RESET } from '../actions';

const initialState = {
    employeeList: [],
    employeeCopy: [],
    search: "",
    vehicleFilter: "",
    roleFilter: ""
};

const EmployeeDetails = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_EMPLOYEE:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default EmployeeDetails;